import React from 'react';

const NotFound = () => {
     return (
          <div className='container text-center'>
               <img className='img-fluid h-25 w-50 mt-5' src="https://previews.123rf.com/images/sodis/sodis1801/sodis180100083/93873938-error-404-page-broken-car-flat-vector-illustration-in-cartoon-style-.jpg?fj=1" alt="" />
          </div>
     );
};

export default NotFound;